import { render, staticRenderFns } from "./SidebarErrorV2.vue?vue&type=template&id=67795f78&scoped=true"
import script from "./SidebarErrorV2.vue?vue&type=script&lang=ts"
export * from "./SidebarErrorV2.vue?vue&type=script&lang=ts"
import style0 from "./SidebarErrorV2.vue?vue&type=style&index=0&id=67795f78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67795f78",
  null
  
)

export default component.exports